import React, { useEffect, useState } from "react";

import { CloseIcon } from "../../lib/icons";

function LeadJourneyPickerModal({
  leads,
  onClose,
  onConfirm,
  open,
  selectedLeadId,
}) {
  const [targetLeadId, setTargetLeadId] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }
    setTargetLeadId(String(selectedLeadId || leads[0]?.id || ""));
  }, [open, selectedLeadId, leads]);

  if (!open) {
    return null;
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <div>
            <p className="modal-kicker">Lead Journey</p>
            <h2>Which client do you want to open?</h2>
          </div>
          <button type="button" className="close-button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        {leads.length ? (
          <div className="form-grid">
            <label className="field-stack full-span">
              <span>Select Client</span>
              <select
                value={targetLeadId}
                onChange={(event) => setTargetLeadId(event.target.value)}
              >
                {leads.map((lead) => (
                  <option key={lead.id} value={lead.id}>
                    {lead.full_name} ({lead.client_id})
                  </option>
                ))}
              </select>
            </label>

            <div className="modal-actions full-span">
              <button type="button" className="secondary-ghost" onClick={onClose}>
                Cancel
              </button>
              <button
                type="button"
                className="primary-button modal-submit"
                onClick={() => onConfirm(targetLeadId)}
                disabled={!targetLeadId}
              >
                Open Journey
              </button>
            </div>
          </div>
        ) : (
          <div className="table-state">No clients are available in the current queue.</div>
        )}
      </div>
    </div>
  );
}

export default LeadJourneyPickerModal;
